export const randomId = () => `id_${Math.random().toString(16).substr(2, 8)}`;
export default randomId;
